import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import IncomingFax from './IncomingFax';
import SortIcons from './ProposalsSortIcons';
const IncomingFaxList = ({
  faxes,
  onDownload,
  onDelete,
  user,
  incomingFaxes,
  deleteMode,
  onRecover,
  onSort,
  sortValue,
}) => {
  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
            {/* {(user.role === 'superAdmin' || user.role === 'companyGroupAdmin') && <th>Fax ID</th>} */}
            <th
              className="cursor-pointer"
              onClick={() => faxes?.length > 0 && onSort('company[name]')}
            >
              Company Name <SortIcons sortObj={sortValue} sortName="company[name]" />
            </th>
            <th className="cursor-pointer" onClick={() => faxes?.length > 0 && onSort('reason')}>
              Description <SortIcons sortObj={sortValue} sortName="reason" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => faxes?.length > 0 && onSort('user[email]')}
            >
              User <SortIcons sortObj={sortValue} sortName="user[email]" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => faxes?.length > 0 && onSort('updatedOn')}
            >
              Date/Time <SortIcons sortObj={sortValue} sortName="updatedOn" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => faxes?.length > 0 && onSort('recieverNumString')}
            >
              To <SortIcons sortObj={sortValue} sortName="recieverNumString" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => faxes?.length > 0 && onSort('senderNum')}
            >
              From <SortIcons sortObj={sortValue} sortName="senderNum" />
            </th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {faxes?.length ? (
            faxes?.map(fax => (
              <IncomingFax
                onRecover={onRecover}
                deleteMode={deleteMode}
                key={fax._id}
                fax={fax}
                onDelete={onDelete}
                onDownload={onDownload}
              />
            ))
          ) : (
            <tr>
              <td colSpan={12}>
                <Alert rowSpan={12} color="info">
                  No Faxes Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(IncomingFaxList);
